<template>
  <Toast position="top-right" class="fixed-top" style="z-index: 10000" />
  <div>
    <RouterView />
  </div>
</template>

<script setup>
  import Toast from "primevue/toast";
  import { RouterView } from "vue-router";
  import { watch } from 'vue';
  import { useSessionWatcher } from '@/composables/handlers/SessionHandler';
  import { useAuthStore } from '@/stores/auth';

  const authStore = useAuthStore();
  const { startWatcher, stopWatcher } = useSessionWatcher();

  watch(
    () => authStore.isAuthenticated,
    (isAuth) => {
      if (isAuth) startWatcher();
      else stopWatcher();
    },
    { immediate: true }
  );

</script>
